(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  var DEFAULT_DURATION = 8000;
  var THUMB_GAP = 20;

  DNB.BlogBanner = {
    init: function () {
      var root = document.querySelector("[data-blog-banner]");
      if (!root || root.getAttribute("data-blog-banner-init") === "1") return;
      root.setAttribute("data-blog-banner-init", "1");

      var state = {
        root: root,
        items: [],
        index: 0,
        prevIndex: 0,
        timer: null,
        duration: DEFAULT_DURATION,
        mediaWrap: root.querySelector("[data-blog-banner-media]"),
        content: root.querySelector("[data-blog-banner-content]"),
        thumbsTrack: root.querySelector("[data-blog-banner-thumbs-track]"),
        progressBar: root.querySelector("[data-blog-banner-progress-bar]"),
        progressCurrent: root.querySelector("[data-blog-banner-progress-current]"),
        progressTotal: root.querySelector("[data-blog-banner-progress-total]"),
        thumbStep: 0,
        raf: null,
        labels: {
          readMore: root.getAttribute("data-read-more") || "DEVAMINI OKU"
        }
      };

      DNB.BlogBanner._state = state;

      if (state.thumbsTrack && state.thumbsTrack.children.length) {
        DNB.BlogBanner._bootFromDom(state);
      }

      window.addEventListener("resize", DNB.BlogBanner._debounce(function () {
        DNB.BlogBanner._measureStep();
        DNB.BlogBanner._updateThumbsTrack(state.index, { instant: true });
      }, 150));
    },

    render: function (items, labels) {
      var state = DNB.BlogBanner._state;
      if (!state || !items || !items.length) return;

      state.items = items;
      state.labels = labels || state.labels || {};
      state.index = 0;
      state.prevIndex = 0;

      if (state.mediaWrap) {
        state.mediaWrap.innerHTML = items.map(function (item, i) {
          return (
            '<img src="' + DNB.BlogBanner._esc(item.imageUrl || "") + '"' +
            ' alt="' + DNB.BlogBanner._esc(item.imageAlt || item.title || "") + '"' +
            ' data-banner-index="' + i + '"' +
            (i === 0 ? ' class="is-active"' : "") +
            ' loading="' + (i === 0 ? "eager" : "lazy") + '">'
          );
        }).join("");
      }

      if (state.thumbsTrack) {
        state.thumbsTrack.innerHTML = items.map(function (item, i) {
          return (
            '<button class="blog-banner__thumb' + (i === 0 ? " is-active" : "") + '"' +
            ' type="button" data-banner-thumb="' + i + '"' +
            ' data-title="' + DNB.BlogBanner._esc(item.title || "") + '"' +
            ' data-excerpt="' + DNB.BlogBanner._esc(item.excerpt || "") + '"' +
            ' data-image-url="' + DNB.BlogBanner._esc(item.imageUrl || item.thumbnailUrl || "") + '"' +
            ' data-url="' + DNB.BlogBanner._esc(item.url || "") + '"' +
            ' data-category="' + DNB.BlogBanner._esc(item.categoryLabel || "") + '">' +
              '<span class="blog-banner__thumb-media">' +
                '<img src="' + DNB.BlogBanner._esc(item.thumbnailUrl || item.imageUrl || "") + '"' +
                ' alt="" loading="' + (i < 4 ? "eager" : "lazy") + '">' +
                (item.categoryLabel
                  ? '<span class="blog-banner__thumb-badge">' + DNB.BlogBanner._esc(item.categoryLabel) + "</span>"
                  : "") +
              "</span>" +
              '<span class="blog-banner__thumb-body">' +
                '<span class="blog-banner__thumb-title">' + DNB.BlogBanner._esc(item.title || "") + "</span>" +
                '<span class="blog-banner__thumb-date">' + DNB.BlogBanner._esc(item.date || "") + "</span>" +
              "</span>" +
            "</button>"
          );
        }).join("");

        DNB.BlogBanner._bindThumbs(state);
        DNB.BlogBanner._measureStep();
        DNB.BlogBanner._updateThumbsTrack(0, { instant: true });
      }

      if (state.progressTotal) {
        state.progressTotal.textContent = DNB.BlogBanner._padIndex(items.length);
      }

      DNB.BlogBanner._go(0, false);
    },

    _bootFromDom: function (state) {
      if (!state.thumbsTrack) return;

      var buttons = state.thumbsTrack.querySelectorAll("[data-banner-thumb]");
      state.items = Array.prototype.map.call(buttons, function (btn) {
        return {
          title: btn.getAttribute("data-title") || "",
          excerpt: btn.getAttribute("data-excerpt") || "",
          imageUrl: btn.getAttribute("data-image-url") || "",
          url: btn.getAttribute("data-url") || "",
          categoryLabel: btn.getAttribute("data-category") || ""
        };
      });

      DNB.BlogBanner._bindThumbs(state);
      DNB.BlogBanner._measureStep();
      DNB.BlogBanner._updateThumbsTrack(0, { instant: true });

      if (state.items.length > 1) {
        DNB.BlogBanner._startProgress();
      } else if (state.progressBar) {
        state.progressBar.style.width = "100%";
      }
    },

    _bindThumbs: function (state) {
      if (!state.thumbsTrack) return;

      Array.prototype.forEach.call(state.thumbsTrack.querySelectorAll("[data-banner-thumb]"), function (btn) {
        btn.addEventListener("click", function () {
          var idx = parseInt(btn.getAttribute("data-banner-thumb"), 10);
          if (isNaN(idx)) return;
          DNB.BlogBanner._go(idx, true);
        });
      });
    },

    _go: function (index, userTriggered) {
      var state = DNB.BlogBanner._state;
      if (!state || !state.items.length) return;

      var total = state.items.length;
      var prevIndex = state.index;

      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      var wrappedToStart = !userTriggered && prevIndex === total - 1 && index === 0;
      state.prevIndex = prevIndex;
      state.index = index;

      var item = state.items[index];

      if (state.content) {
        var readMore = state.labels.readMore || "DEVAMINI OKU";
        state.content.innerHTML =
          (item.categoryLabel
            ? '<span class="blog-banner__badge">' + DNB.BlogBanner._esc(item.categoryLabel) + "</span>"
            : "") +
          '<h2 class="blog-banner__title">' + DNB.BlogBanner._esc(item.title || "") + "</h2>" +
          (item.excerpt
            ? '<p class="blog-banner__excerpt">' + DNB.BlogBanner._esc(item.excerpt) + "</p>"
            : "") +
          (item.url
            ? '<a class="btn blog-banner__cta" href="' + DNB.BlogBanner._esc(item.url) + '">' +
                DNB.BlogBanner._esc(readMore) +
              "</a>"
            : "");
      }

      if (state.mediaWrap) {
        Array.prototype.forEach.call(state.mediaWrap.querySelectorAll("img"), function (img, i) {
          img.classList.toggle("is-active", i === index);
        });
      }

      if (state.thumbsTrack) {
        Array.prototype.forEach.call(state.thumbsTrack.querySelectorAll(".blog-banner__thumb"), function (btn, i) {
          btn.classList.toggle("is-active", i === index);
        });

        if (wrappedToStart) {
          DNB.BlogBanner._updateThumbsTrack(0, { fast: true });
        } else if (userTriggered && index === 0 && prevIndex > 0) {
          DNB.BlogBanner._updateThumbsTrack(0);
        } else {
          DNB.BlogBanner._updateThumbsTrack(index);
        }
      }

      if (state.progressCurrent) {
        state.progressCurrent.textContent = DNB.BlogBanner._padIndex(index + 1);
      }

      DNB.BlogBanner._startProgress();
    },

    _measureStep: function () {
      var state = DNB.BlogBanner._state;
      if (!state || !state.thumbsTrack) return;

      var thumb = state.thumbsTrack.querySelector(".blog-banner__thumb");
      if (!thumb) {
        state.thumbStep = 0;
        return;
      }

      var styles = window.getComputedStyle(state.thumbsTrack);
      var gap = parseFloat(styles.columnGap || styles.gap) || THUMB_GAP;
      state.thumbStep = thumb.offsetWidth + gap;
    },

    _updateThumbsTrack: function (index, options) {
      var state = DNB.BlogBanner._state;
      if (!state || !state.thumbsTrack || !state.thumbStep) return;

      options = options || {};
      var track = state.thumbsTrack;
      var offset = index * state.thumbStep;

      if (options.instant) {
        track.style.transition = "none";
        track.style.transform = "translate3d(-" + offset + "px, 0, 0)";
        track.offsetHeight;
        track.style.transition = "";
        return;
      }

      var duration = options.fast ? "0.28s" : "0.45s";
      track.style.transition = "transform " + duration + " ease";
      track.style.transform = "translate3d(-" + offset + "px, 0, 0)";
    },

    _startProgress: function () {
      var state = DNB.BlogBanner._state;
      if (!state) return;

      if (state.timer) clearTimeout(state.timer);
      if (state.raf) cancelAnimationFrame(state.raf);

      if (!state.progressBar || state.items.length <= 1) {
        if (state.progressBar) state.progressBar.style.width = "100%";
        return;
      }

      var duration = state.duration;
      var tweenStart = performance.now();

      function tick(now) {
        var elapsed = now - tweenStart;
        var pct = Math.min(1, elapsed / duration);
        state.progressBar.style.width = (pct * 100) + "%";
        if (pct < 1) {
          state.raf = requestAnimationFrame(tick);
        }
      }

      state.progressBar.style.width = "0%";
      state.raf = requestAnimationFrame(tick);

      state.timer = setTimeout(function () {
        DNB.BlogBanner._go(state.index + 1, false);
      }, duration);
    },

    _padIndex: function (num) {
      return num < 10 ? "0" + num : String(num);
    },

    _esc: function (str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    _debounce: function (fn, wait) {
      var t;
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }
  };
})(window, document);
